export default (percentage: number) => {
  return 1 * (percentage /= 1) * percentage * percentage * percentage;
};
